import { useEffect, useState } from 'react';

interface UseLoadingOptions {
  duration?: number;
  isOpen?: boolean;
  external?: boolean;
}

export function useLoading(options: UseLoadingOptions | number = {}) {
  const config =
    typeof options === 'number'
      ? { duration: options, isOpen: true, external: false }
      : { duration: 1500, isOpen: true, external: false, ...options };

  const { duration, isOpen, external } = config;
  const [internal, setInternal] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setInternal(false);
      return;
    }

    setInternal(true);

    const timer = setTimeout(() => {
      setInternal(false);
    }, duration);

    return () => clearTimeout(timer);
  }, [isOpen, duration]);

  return {
    loading: external || internal
  };
}

export default useLoading;
